const pluggerFields = [
  {
    label: 'First Name',
    name: 'first_name',
    type: 'text',
    required: 'required',
    className: 'grid-span-6 grid-xs-span-12'
  },
  {
    label: 'Last Name',
    name: 'last_name',
    type: 'text',
    required: 'required',
    className: 'grid-span-6 grid-xs-span-12'
  },
  {
    label: 'Address',
    name: 'street_address',
    type: 'text',
    required: false,
    className: 'grid-span-12 grid-xs-span-12'
  },
  {
    label: 'City',
    name: 'city',
    type: 'text',
    required: false,
    className: 'grid-span-6 grid-xs-span-12'
  },
  {
    label: 'State',
    name: 'state',
    type: 'text',
    required: false,
    className: 'grid-span-6 grid-xs-span-12'
  },
  {
    label: 'Zip Code',
    name: 'zipcode',
    type: 'text',
    required: 'required',
    className: 'grid-span-6 grid-xs-span-12'
  },
  {
    label: 'Email',
    name: 'email_address',
    type: 'email',
    required: 'required',
    className: 'grid-span-6 grid-xs-span-12'
  },
  {
    label: 'Primary Phone No.',
    name: 'primary_phone',
    type: 'phone',
    required: 'required',
    className: 'grid-span-12 grid-xs-span-12'
  },
  {
    label: 'Mobile Phone No.',
    name: 'mobile_phone',
    type: 'phone',
    className: 'grid-span-6 grid-xs-span-12'
  },
  {
    label: 'Secondary Phone No.',
    name: 'evening_phone',
    type: 'phone',
    className: 'grid-span-6 grid-xs-span-12'
  },
  {
    label: 'Birthday',
    name: 'birthday_month',
    type: 'select',
    options: [
      {
        label: 'Month',
        value: ''
      },
      {
        label: 'January',
        value: 1
      },
      {
        label: 'February',
        value: 2
      },
      {
        label: 'March',
        value: 3
      },
      {
        label: 'April',
        value: 4
      },
      {
        label: 'May',
        value: 5
      },
      {
        label: 'June',
        value: 6
      },
      {
        label: 'July',
        value: 7
      },
      {
        label: 'August',
        value: 8
      },
      {
        label: 'September',
        value: 9
      },
      {
        label: 'October',
        value: 10
      },
      {
        label: 'November',
        value: 11
      },
      {
        label: 'December',
        value: 12
      }
    ],
    required: 'required',
    className: 'grid-span-4'
  },
  {
    label: '',
    name: 'birthday_day',
    type: 'select_range',
    firstItem: {
      label: 'Day',
      value: ''
    },
    rangeStart: 1,
    rangeEnd: 31,
    required: 'required',
    className: 'grid-span-4 field__hidden-label'
  },
  {
    label: '',
    name: 'birthday_year',
    type: 'select_range',
    firstItem: {
      label: 'Year',
      value: ''
    },
    rangeStart: 1900,
    rangeEnd: new Date().getFullYear(),
    reverseRange: true,
    required: 'required',
    className: 'grid-span-4 field__hidden-label'
  },
  {
    label: 'Tell us your story (Maximum 250 words). Please limit your response to information you would be comfortable sharing on air.',
    name: 'story',
    type: 'textarea',
    required: 'required',
    maxwords: 250,
    rows: 4,
    maxlength: '2500',
    className: 'grid-span-12'
  },
  {
    label: 'attach photo',
    name: 'submission_image[file]',
    type: 'file',
    className: 'grid-span-12 field__file'
  },
  {
    label: 'Are you willing to appear on the show?',
    name: 'show_appearance',
    type: 'radio',
    required: 'required',
    options: [
      {
        label: 'Yes',
        value: '1'
      },
      {
        label: 'No',
        value: '0'
      }
    ],
    className: 'grid-span-12'
  },
  {
    key: 'social_media',
    type: 'api',
    heading: 'Share social handles',
    desc: '',
    className: 'grid-span-12'
  },
  {
    label: 'By submitting any material and personal information, including but not limited to, uploading video, photos or stories, I give my consent that all such content may be published, edited, or otherwise used by Big Ticket Pictures, Inc., in whole or in part, on or in connection with the Drew Barrymore Show (including on air) and/or its affiliated digital properties and partners in all media and I represent that I have the right to grant such rights. I understand and acknowledge that I will receive no payment for any suggestions, ideas, or other content submitted.',
    name: 'terms_additional',
    type: 'checkbox',
    required: 'required',
    className: 'grid-span-12'
  },
  {
    label: 'By pressing submit, you confirm that you have read and agree to CBS Interactive\'s <a href=\'https://cbsinteractive.com/legal/cbsi/terms-of-use/\' target=\'_blank\'>Terms of Use</a> and acknowledge the data collection and usage practices outlined in CBS Interactive\'s <a href=\'https://www.viacomcbsprivacy.com/policy\' target=\'_blank\'>Privacy Policy</a>. Any material or personal information submitted will be used in part for the purpose of evaluating whether to invite you to appear on the show.',
    name: 'terms_accepted',
    type: 'checkbox',
    required: 'required',
    className: 'grid-span-12'
  }
];

Object.freeze(pluggerFields);

export default pluggerFields;